import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, isDirty, reset, isValid, getFormSyncErrors, touch } from 'redux-form';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as lookupSelectors, actions as lookupActions } from 'ducks/lookup';
import FilterDialog from './FilterDialog';
import { selectors as configSelectors } from 'ducks/appConfig';

const mapStateToProps = (state, ownProps) => (
  {
    operationMode: operationSelectors.operationMode(state),
    validate: ownProps.validate,
    isV2: configSelectors.isV2(state),
    isV3: configSelectors.isV3(state),
    form: ownProps.formName,
    key: ownProps.formName,
    values: getFormValues(ownProps.formName)(state),
    dirty: isDirty(ownProps.formName)(state),
    isValid: isValid(ownProps.formName)(state),
    lookupList: lookupSelectors.all(state),
    formSyncErrors: getFormSyncErrors(ownProps.formName)(state),
  });

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    reset: reset,
    touchFormFields: touch,
    fetchLookups: lookupActions.fetch,
  },
  dispatch);

export default compose<any, any, any>(
  connect(mapStateToProps, {}),
  reduxForm({
    enableReinitialize: true,
    destroyOnUnmount: false
  })
)(connect(mapStateToProps, mapDispatchToProps)(FilterDialog));
